
<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :title="$lang.show_change_role"
      :url="url"
      :filterCatch="false"
      :hasFilter="true"
      :html="false"
      @updatePermissions="updatePermissions"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="
            py-1
            mb-3
            border-bottom
            d-md-flex d-block
            align-items-center
            justify-content-between
          "
        >
          <div class="d-flex align-items-center">
            <span
              class="
                mr-1
                fs_1_3rem
                w_h_35
                border
                bg-light
                rounded-circle
                d-flex
                align-items-center
                justify-content-center
                text-success
              "
            >
              <mdicon name="history" />
            </span>
            <b class="px-1 fs_1rem" v-text="''" />
          </div>
          <small
            class="
              text-muted
              d-md-block d-flex
              align-items-center
              justify-content-between
            "
          >
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="
                pathOr(null, ['created_by'], item) &&
                pathOr(null, ['created_by'], item) !== getFullName(item)
              "
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </small>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.old_roles" />:
              <b-badge
                v-for="(role, i) in pathOr([], ['old_role'], item)"
                :key="i"
                variant="danger"
                class="mr-2 fs_13"
                v-text="role"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.new_roles" />:
              <b-badge
                v-for="(role, i) in pathOr([], ['new_role'], item)"
                :key="i"
                variant="success"
                class="mr-2 fs_13"
                v-text="role"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "change-role-list",
  components: {
    SearchCard,
  },
  props: {
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      permissions: [],
      addEditModal: false,
      addEditModalMode: "add",
      itemId: null,
      confirmModal: false,
      confirmLoading: false,
    };
  },
  computed: {
    url() {
      return generateApiUrl(
        ["profile", "parvandeh_role_log"],
        [this.parvandehCode]
      );
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getFullName(item) {
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      return `${name} ${family}`;
    },
  },
};
</script>
<style scoped lang="scss">
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
